<template>
  <div class="contract-approval">
    <div class="header-section">
      <h2 class="page-title">Accettazione Contratti</h2>
      <p class="subtitle">Revisione e approvazione dei contratti AGF</p>
    </div>

    <div class="document-preview">
      <div class="document-controls">
        <span class="document-title">Contratto #AGF-2025-0042</span>
        <div class="control-buttons">
          <Button icon="pi pi-download" class="p-button-rounded p-button-text" v-tooltip.top="'Scarica documento'"
            @click="scaricaDocumento" />
          <Button icon="pi pi-search-plus" class="p-button-rounded p-button-text" v-tooltip.top="'Zoom in'"
            @click="zoomIn" />
          <Button icon="pi pi-search-minus" class="p-button-rounded p-button-text" v-tooltip.top="'Zoom out'"
            @click="zoomOut" />
        </div>
      </div>

      <div class="document-viewport">
        <div class="document-page" :style="{ transform: `scale(${livelloZoom})` }">
          <div class="document-header">
            <div class="logo">AGF ENERGIA</div>
            <div class="document-type">CONTRATTO DI FORNITURA</div>
          </div>

          <div class="document-content">
            <div class="section">
              <h3>DATI CLIENTE</h3>
              <div class="data-row">
                <span class="label">Ragione Sociale:</span>
                <span class="value">Azienda Demo S.p.A.</span>
              </div>
              <div class="data-row">
                <span class="label">Partita IVA:</span>
                <span class="value">IT12345678901</span>
              </div>
              <div class="data-row">
                <span class="label">Indirizzo:</span>
                <span class="value">Via Roma 123, 70121 Bari (BA)</span>
              </div>
            </div>

            <div class="section">
              <h3>DETTAGLI FORNITURA</h3>
              <div class="data-row">
                <span class="label">Tipo:</span>
                <span class="value">Energia Elettrica</span>
              </div>
              <div class="data-row">
                <span class="label">POD:</span>
                <span class="value">IT001E12345678</span>
              </div>
              <div class="data-row">
                <span class="label">Offerta:</span>
                <span class="value">Business Fix 2025</span>
              </div>
              <div class="data-row">
                <span class="label">Prezzo F1:</span>
                <span class="value">0,24 €/kWh</span>
              </div>
            </div>

            <div class="section">
              <h3>FIRME</h3>
              <div class="signature-box">
                <div class="signature client-signature">
                  <div class="signature-line"></div>
                  <div class="signature-label">Firma Cliente</div>
                </div>
                <div class="signature company-signature">
                  <div class="signature-img">Francesco Rossi</div>
                  <div class="signature-line"></div>
                  <div class="signature-label">Firma AGF Energia</div>
                </div>
              </div>
            </div>
          </div>

          <div class="document-footer">
            <div class="page-number">Pagina 1 di 3</div>
            <div class="footer-text">Documento generato il 05/05/2025</div>
          </div>
        </div>
      </div>
    </div>

    <div class="action-container">
      <div class="info-grid">
        <div class="info-box">
          <i class="pi pi-info-circle info-icon"></i>
          <div class="info-content">
            <span class="info-title">Cliente</span>
            <span class="info-value">Azienda Demo S.p.A.</span>
          </div>
        </div>

        <div class="info-box">
          <i class="pi pi-calendar info-icon"></i>
          <div class="info-content">
            <span class="info-title">Data sottoscrizione</span>
            <span class="info-value">02/05/2025</span>
          </div>
        </div>

        <div class="info-box">
          <i class="pi pi-user info-icon"></i>
          <div class="info-content">
            <span class="info-title">Agente</span>
            <span class="info-value">Marco Verdi</span>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <Button label="Blocca contratto" icon="pi pi-times" class="p-button-danger btn-block"
          @click="bloccaContratto" />
        <Button label="Approva contratto" icon="pi pi-check" class="p-button-success btn-approve"
          @click="approvaContratto" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-wizard';
import { useToast } from 'primevue/usetoast';

export default {
  setup() {
    const toast = useToast();
    const loading = ref(false);
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);

    const statoContratto = ref('in_attesa');
    const livelloZoom = ref(1);
    const dettagliContratto = ref({
      id: 'AGF-2025-0042',
      cliente: {
        ragioneSociale: 'Azienda Demo S.p.A.',
        partitaIva: 'IT12345678901',
        indirizzo: 'Via Roma 123, 70121 Bari (BA)'
      },
      fornitura: {
        tipo: 'Energia Elettrica',
        pod: 'IT001E12345678',
        offerta: 'Business Fix 2025',
        prezzoF1: 0.24
      },
      agente: 'Marco Verdi',
      dataSottoscrizione: '02/05/2025'
    });

    const zoomIn = () => {
      if (livelloZoom.value < 1.5) {
        livelloZoom.value += 0.1;
      }
    };

    const zoomOut = () => {
      if (livelloZoom.value > 0.6) {
        livelloZoom.value -= 0.1;
      }
    };

    const scaricaDocumento = () => {
      toast.add({
        severity: 'info',
        summary: 'Download avviato',
        detail: 'Il download del contratto inizierà a breve',
        life: 3000
      });

      // BACKEND 
      // service.scaricaContratto(dettagliContratto.value.id)
      //   .then((response) => {
      //     // Logica per gestire il download
      //   })
      //   .catch((error) => {
      //     toast.add({
      //       severity: 'error',
      //       summary: 'Errore',
      //       detail: 'Impossibile scaricare il documento',
      //       life: 3000
      //     });
      //   });
    };

    const approvaContratto = () => {
      loading.value = true;

      // Simulazione della chiamata API
      setTimeout(() => {
        statoContratto.value = 'approvato';
        loading.value = false;

        toast.add({
          severity: 'success',
          summary: 'Contratto approvato',
          detail: 'Il contratto è stato approvato con successo',
          life: 3000
        });
      }, 1000);

      // Implementazione futura con il backend
      // service.approvaContratto(dettagliContratto.value.id)
      //   .then((response) => {
      //     statoContratto.value = 'approvato';
      //     toast.add({
      //       severity: 'success',
      //       summary: 'Contratto approvato',
      //       detail: 'Il contratto è stato approvato con successo',
      //       life: 3000
      //     });
      //   })
      //   .catch((error) => {
      //     toast.add({
      //       severity: 'error',
      //       summary: 'Errore',
      //       detail: 'Impossibile approvare il contratto',
      //       life: 3000
      //     });
      //   })
      //   .finally(() => {
      //     loading.value = false;
      //   });
    };

    const bloccaContratto = () => {
      loading.value = true;

      setTimeout(() => {
        statoContratto.value = 'bloccato';
        loading.value = false;

        toast.add({
          severity: 'error',
          summary: 'Contratto bloccato',
          detail: 'Il contratto è stato bloccato',
          life: 3000
        });
      }, 1000);

      // Implementazione futura con il backend
      // service.bloccaContratto(dettagliContratto.value.id)
      //   .then((response) => {
      //     statoContratto.value = 'bloccato';
      //     toast.add({
      //       severity: 'error',
      //       summary: 'Contratto bloccato',
      //       detail: 'Il contratto è stato bloccato',
      //       life: 3000
      //     });
      //   })
      //   .catch((error) => {
      //     toast.add({
      //       severity: 'error',
      //       summary: 'Errore',
      //       detail: 'Impossibile bloccare il contratto',
      //       life: 3000
      //     });
      //   })
      //   .finally(() => {
      //     loading.value = false;
      //   });
    };

    const caricaDatiContratto = async (id) => {
      loading.value = true;

      try {
        console.log('Caricati dati del contratto:', dettagliContratto.value.id);
      } catch (errore) {
        toast.add({
          severity: 'error',
          summary: 'Errore di caricamento',
          detail: 'Impossibile caricare i dati del contratto',
          life: 3000
        });
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      caricaDatiContratto('AGF-2025-0042');
    });

    return {
      loading,
      livelloZoom,
      dettagliContratto,
      statoContratto,
      approvaContratto,
      bloccaContratto,
      zoomIn,
      zoomOut,
      scaricaDocumento
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.contract-approval {
  font-family: 'Montserrat', sans-serif;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 1.5rem;
}

.header-section {
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.page-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.subtitle {
  color: #7f8c8d;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.document-preview {
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  overflow: hidden;
  flex-grow: 1;
}

.document-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: #ffffff;
  border-bottom: 1px solid #eaeaea;
}

.document-title {
  font-weight: 600;
  color: #2c3e50;
}

.document-viewport {
  padding: 2rem;
  height: calc(100vh - 300px);
  min-height: 500px;
  overflow-y: auto;
  display: flex;
  justify-content: center;
}

.document-page {
  background-color: white;
  width: 100%;
  max-width: 800px;
  min-height: 1000px;
  padding: 3rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.3s ease;
  transform-origin: top center;
}

.document-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  border-bottom: 2px solid #eaeaea;
  padding-bottom: 1rem;
}

.logo {
  font-weight: 700;
  font-size: 1.5rem;
  color: #3498db;
}

.document-type {
  font-weight: 600;
  color: #7f8c8d;
}

.section {
  margin-bottom: 2rem;
}

.section h3 {
  font-size: 1.2rem;
  color: #3498db;
  margin-bottom: 1rem;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 0.5rem;
}

.data-row {
  display: flex;
  margin-bottom: 0.5rem;
}

.label {
  flex: 0 0 150px;
  font-weight: 600;
  color: #7f8c8d;
}

.value {
  flex: 1;
  color: #2c3e50;
}

.signature-box {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.signature {
  width: 45%;
}

.signature-line {
  border-bottom: 1px solid #2c3e50;
  margin-bottom: 0.5rem;
  height: 2rem;
}

.signature-img {
  font-family: 'Brush Script MT', cursive;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #3498db;
}

.signature-label {
  font-size: 0.8rem;
  color: #7f8c8d;
}

.document-footer {
  position: absolute;
  bottom: 1rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 3rem;
  color: #7f8c8d;
  font-size: 0.8rem;
}

.action-container {
  background-color: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.info-grid {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.info-box {
  display: flex;
  align-items: center;
  flex: 0 0 30%;
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.info-icon {
  font-size: 1.5rem;
  color: #3498db;
  margin-right: 1rem;
}

.info-content {
  display: flex;
  flex-direction: column;
}

.info-title {
  font-size: 0.8rem;
  color: #7f8c8d;
}

.info-value {
  font-weight: 600;
  color: #2c3e50;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.btn-block,
.btn-approve {
  padding: 0.8rem 1.5rem;
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .info-box {
    flex: 0 0 100%;
  }

  .action-buttons {
    flex-direction: column;
  }

  .document-page {
    padding: 1.5rem;
  }

  .document-footer {
    padding: 0 1.5rem;
  }
}
</style>